export { default } from './MultiSelect.svelte';
// get the label key from an option object or the option itself if it's a string or number
export const get_label = (op) => (op instanceof Object ? op.label : op);
// fallback on label if option is object and value is undefined
export const get_value = (op) => op instanceof Object ? op.value ?? op.label : op;
